import cx from 'classnames';
import React from 'react';
import Button from 'react-bootstrap/Button';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

/* eslint-disable react/no-danger */

export interface PageProps {
  className?: string;
  code?: number;
  heading: string;
  message: string;
  icon?: string;
  reset?: () => void;
}

const Container = styled.div`
  svg {
    --fa-secondary-color: var(--gamma);
  }
`;

const Code = styled.div`
  font-size: 4.5rem;
`;

export const Page = ({
  className,
  code,
  heading,
  message,
  icon,
  reset
}: PageProps): React.ReactElement => {
  const history = useHistory();

  const handler = (event: React.MouseEvent): void => {
    event.preventDefault();

    // Reset the error boundary
    reset?.();

    history.push('/home');
  };

  return (
    <Container className={cx('d-flex', 'flex-column', 'align-items-center', className)}>
      {code && <Code className='text-white60 font-weight-bold pb-32px'>{code}</Code>}

      <i className={`fad fa-3x ${icon ?? 'fa-camera-movie'}`} />

      <div className='pt-12px pb-8px font-size-24px text-white'>{heading}</div>

      <p
        className='pb-20px text-center text-white60'
        dangerouslySetInnerHTML={{ __html: message }}
      />

      <Button className='btn-wide' size='lg' onClick={handler}>
        &nbsp;Back to Dashboard
      </Button>
    </Container>
  );
};
